import * as React from "react";
import "./BODetailTopBarStyle.css";
import { NavLink } from "react-router-dom";

const BODetailTopBar = ({ children }: { children: any }) => {
  return <div className="BODetailTopBar">{children}</div>;
};

const BODetailTopBarItem = ({
  text,
  link
}: {
  text: string;
  link?: string;
}) => {
  return (
    <NavLink
      className="BODetailTopBarItem"
      to={!!link ? link : null}
      activeClassName="selected"
    >
      {text}
    </NavLink>
  );
};

export { BODetailTopBar, BODetailTopBarItem };
